import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from 'containers/App';
import Provider from 'services/context';

import 'assets/Roboto/font.css';
import 'assets/Barlow/font.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<Provider>
		<App />
	</Provider>
);
